import React, { useEffect, useState } from 'react';

import './App.css';
import { Routes, Route, Link, useParams, Navigate, useNavigate } from "react-router-dom";
import { sk } from './language.js';
import { CategorySelect, Colors, CopyData, Debug, DialogEnterText, DialogInfo, DialogLogin, DialogYesNo, EmployeeSelect, EmptyList, GetImageLink, GetPrice, Init, LoadBookingNote, Loading, Menu, MenuTitle, MenuTop, PlusMinus, SaveBookingNote, ShowError, ShowOK, TemplateWindow, TextLine, TextSearch, Today } from './items';
import { styles } from './styles';
import { Backdrop, Button, Checkbox, CircularProgress, FormControlLabel, IconButton, InputAdornment, MenuItem, Pagination, Paper, Select, TextField, useMediaQuery } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faCheckCircle, faInfo, faInfoCircle, faL, faLayerGroup, faList, faListAlt, faPen, faQuestion, faShoppingBasket, faShoppingCart, faXmark } from '@fortawesome/free-solid-svg-icons';
import { ClientCard } from './client_card';
import { EditorHtml } from './Editor';
import { ProductDialog } from './product_dialog';
import { ConvertToPrice } from './items';
import { IsEmpty } from './items';
import { notNumber } from './items';
import { Photos } from './photos';
import { DialogImagePreview } from './items';
import { FormError } from './items';
import { TextInput } from './items';
import { Graph } from './graph';
import { GetDate } from './items';
import { setItem } from 'localforage';


export const ProductsBooking = (props) => {
    const [isBusy, setBusy] = useState(false);
    const [isUpdating, setUpdating] = useState(false);
    const [index, setIndex] = useState(0);
    const [search, setSearch] = useState('');
    const [overID, setOverID] = useState(-1);

    // KATEGORIE
    const [categories, setCategories] = useState(false);
    const [subCategories, setSubCategories] = useState(false);
    const [subCategoryID, setSubCategoryID] = useState(0);

    // PRODUKTY
    const [items, setItems] = useState(false);
    const [itemsFiltered, setItemsFiltered] = useState(false);
    const [page, setPage] = useState(0);
    const [pageMax, setPageMax] = useState(0);
    const itemsMax = 24;

    // EDITING + NOVY PRODUKT
    const [itemSelected, setItemSelected] = useState(false);
    const [editing, setEditing] = useState(false);
    const [showProduct, setShowProduct] = useState(false);

    // SUMA
    const [sum, setSum] = useState(0);

    // KOSIK
    const [showCard, setShowCard] = useState(false);

    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);

    const menuWidth = props.isSmall ? 0 : 250;
    const rowHeight = props.isSmall ? 150 : 100;
    const rowWidth = 850;
    const selectHeight = props.isSmall ? 60 : 0;

    // COLORS
    const font_selected = global.theme_black;
    const font_disabled = global.theme_darker;

    const no_image = require('./react/app/no_image.jpg');

    let { func } = props;
    var lang = props.lang;

    var running = false;

    useEffect(() => {
        if (running == false) {
            running = true;
            db_get();
        }

    }, []);

    const db_get = async () => {
        setBusy(true);
        try {
            const response = await fetch(
                global.db_url + 'categories', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    salon_id: props.user.id,
                    language: props.language,
                    //default: lang.products_my,
                    cabine: lang.cabine,
                    action: lang.action,
                })
            })

            const json = await response.json();

            if (json.ok > 0) {
                var tmp = json.items;
                tmp = tmp.filter(x => x.enabled == true);
                setCategories(tmp);
                if (tmp != false) {
                    db_products(tmp[0].id);
                    setIndex(tmp[0].id);
                }
            }
            //setBusy(false);

        } catch (error) {
            console.log(error);
            setBusy(false);
        }
    }

    const db_products = async (category_id) => {
        setBusy(true);
        try {
            const response = await fetch(
                global.db_url + 'products', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    salon_id: props.user.id,
                    category_id: category_id,
                    language: props.language,
                    booking: true
                })
            })

            const json = await response.json();
            Debug(json);
            if (json.ok > 0) {
                setSubCategories(json.categories);
                setSubCategoryID(0);
                var tmp = json.products;

                if (tmp != false) {
                    tmp.sort((a, b) => {
                        if (a.label > b.label) {
                            return 1;
                        } else {
                            return -1;
                        }
                    })
                }

                if (tmp != false) {
                    setItems(tmp);
                    PageInit(tmp);
                } else {
                    setItems(false);
                    setItemsFiltered(false);
                }
                setSum(json.booking_sum);
            }
            setBusy(false);

        } catch (error) {
            console.log(error);
            setBusy(false);
        }
    }


    const db_search = async (search) => {
        setBusy(true);
        try {
            const response = await fetch(
                global.db_url + 'product_search', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    salon_id: props.user.id,
                    search: search,
                    language: props.language,
                    not_others: true,
                    booking: true
                })
            })

            const json = await response.json();

            if (json.ok > 0) {
                setSubCategories(false);
                setSubCategoryID(0);
                var tmp = json.products;

                if (tmp != false) {
                    tmp.sort((a, b) => {
                        if (a.label > b.label) {
                            return 1;
                        } else {
                            return -1;
                        }
                    })
                    setItems(tmp);
                    PageInit(tmp);
                    setIndex(-99);
                } else {
                    setItems(false);
                    setItemsFiltered(false);
                    setIndex(-99);
                }

            }
            setBusy(false);

        } catch (error) {
            console.log(error);
            setBusy(false);
        }
    }


    const db_sum = async () => {

        try {
            const response = await fetch(
                global.db_url + 'products_booking_sum', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    salon_id: props.user.id,
                })
            })

            const json = await response.json();

            if (json.ok > 0) {
                setSum(json.sum);

            }

        } catch (error) {
            console.log(error);
        }
    }

    const db_update = async (data) => {
        setUpdating(true);
        try {
            const response = await fetch(
                global.db_url + 'product_booking_update', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    data: data,
                })
            })

            const json = await response.json();

            setUpdating(false);
            if (json.ok > 0) {
                var product = items.find(x => x.id == data.product_id);
                if (product != undefined) {
                    product.quantity = data.quantity;
                }

                var product = itemsFiltered.find(x => x.id == data.product_id);
                if (product != undefined) {
                    product.quantity = data.quantity;
                }

                setSum(json.sum);
            }

        } catch (error) {
            setUpdating(false);
            console.log(error);
        }
    }

    const Press = (typ, value) => {
        func(typ, value);
    }

    const Close = () => {
        Press(0, 0);
    }

    const ChangeIndex = (id) => {
        setIndex(id);
        setSubCategoryID(0);
        setSearch('');
        db_products(id);
    }

    const CategorySelectResult = (id) => {
        setSubCategoryID(id);
        Redraw(items, 0, search, id);
    }

    const Search = (text) => {
        setSearch(text);
        /*
        setSubCategoryID(0);
        Redraw(items, 0, text, 0);
        */
        if (text.trim().length > 2) {
            db_search(text.trim());
        }
        if (text == '') {
            setItems(false);
            setItemsFiltered(false);
            setIndex(-10);
        }
    }

    const Redraw = (items, p, search, sub_category) => {
        // REDRAW PRODUKTOV
        var data = items;
        if (search.trim() != '') {
            // filtrovanie podla hladaneho retazca
            //var words = search.split(' ');
            //data = items.filter(x => FindWords(x.label, x.keywords, words));
        } else {

            if (sub_category > 0) {
                // filtrovanie vybratej kategórie
                data = items.filter(x => parseInt(x.category_id) == sub_category);
            }

        }

        var count = data.length;
        count = Math.ceil(count / itemsMax);
        setPageMax(count);

        data = data.slice(itemsMax * p, (itemsMax * p) + itemsMax)
        setItemsFiltered(data);

        if (count == 0) {
            setItemsFiltered(false);
        }

        setPage(p);
        GoToStart();
    }

    function FindWords(label, keywords, words) {
        // hladanie retazca v nazve a keywords
        var result = 0;
        words.forEach(word => {
            if (label.toLowerCase().includes(word.toLowerCase()) || keywords.toLowerCase().includes(word.toLowerCase())) {
                result += 1;
            }

        });
        // ak je pocet najdených slov == poctu hladaných slov -> je zhoda
        return words.length == result;
    }

    const PageInit = (tmp) => {
        // VYPOCET POCTU STRAN
        setItemsFiltered(tmp);

        var count = tmp.length;
        count = Math.ceil(count / itemsMax);
        setPageMax(count);

        Redraw(tmp, 0, '', 0);
    }

    const PageChange = (event, value) => {
        // PAGINATION
        var page_ = value - 1;

        setPage(page_);
        Redraw(items, page_, search, subCategoryID);
    };

    const GoToStart = () => {
        setTimeout(() => {
            const element = document.getElementById('id_products');

            if (element != null) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }, 100);
    }

    const PlusMinusResult = (value, item) => {

        let data = {
            salon_id: props.user.id,
            product_id: item.id,
            quantity: value,
            sended: false,
            booking_id: 0,
            quantity_original: value,
            cost: item.cost_price
        }

        db_update(data);
    }

    const BookingPreview = () => {

    }


    const ProductCardResult = (redraw) => {
        setShowCard(false);

        if (redraw == true) {
            setSearch('');
            db_products(index);
        }
    }

    // ------------------------------------------------------------------------------------
    // NAHLAD PRODUKTU
    // ------------------------------------------------------------------------------------

    const Edit = (item) => {
        if (props.user.typ == global.account_salon) {
            setItemSelected(item);
            setEditing(true);
            setShowProduct(true);
        }
    }

    const ProductDialogResult = (product) => {

        itemSelected.quantity = product.quantity
        setShowProduct(false);
        db_sum();
    }

    /*
    *
    * =================================================================================================================
    * RENDER
    * =================================================================================================================
    *
    */
    return (
        <Paper elevation={global.menu_elevation} style={{ width: props.width, height: props.height, background: global.themes[props.theme].theme_window_background, borderRadius: props.radius }}>
            <div style={{ ...styles.BlockRow, height: global.dialog_bar_height, borderTopLeftRadius: props.radius, borderTopRightRadius: props.radius, background: global.themes[props.theme].window_bar_color }}>
                {props.isSmall ? null :
                    <div style={{ ...styles.Block, width: 100, height: global.dialog_bar_height }}>
                        <div style={{ ...styles.Block, width: global.dialog_icon_size, height: global.dialog_icon_size, background: global.themes[props.theme].icon_background, borderRadius: 7 }} >
                            <FontAwesomeIcon style={{ height: 20, color: global.theme_white }} icon={faList} />
                        </div>
                    </div>
                }
                <div style={{ ...styles.Block, width: props.isSmall ? '60%' : '55%', height: global.dialog_bar_height }}>
                    <div style={{ ...styles.BlockLeft, height: global.dialog_bar_height, justifyContent: 'center' }}>
                        <p style={{ ...styles.TextDialogLabel, textAlign: 'left', marginLeft: props.isSmall ? 10 : 0 }}>{props.title}</p>
                        {props.isSmall ? null :
                            <p style={{ ...styles.TextDialogSubLabel, marginTop: 4 }}>{props.sub_title}</p>
                        }
                    </div>
                </div>
                <div style={{ ...styles.Block, width: props.isSmall ? 160 : 300, height: global.dialog_bar_height, justifyContent: 'center' }}>
                    <TextSearch lang={props.lang} isSmall={props.isSmall} func={Search.bind(this)} />
                    {/*
                    <TextField
                        value={search}
                        onInput={e => Search(e.target.value)}
                        size="small"
                        autoCapitalize="off"
                        autoComplete="off"
                        autoCorrect="off"
                        style={{ width: props.isSmall ? 150 : 250 }}
                        placeholder={lang.search_in_category}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter') {
                            }
                        }}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">
                                <IconButton onClick={() => Search('')} style={{ width: 20, height: 20 }}>
                                    <FontAwesomeIcon style={{ width: 10 }} icon={faXmark} />
                                </IconButton>
                            </InputAdornment>,
                            style: { backgroundColor: global.theme_white, borderRadius: 30 },
                        }}
                        variant="outlined"
                    />
                    */}
                </div>
                {props.isSmall ? null :
                    <div style={{ ...styles.Block, width: 250, height: global.dialog_bar_height, justifyContent: 'center' }}>
                        <Button onClick={() => setShowCard(true)} style={{ ...styles.ButtonBlue, width: 200, marginLeft: 20 }}>
                            {/*<FontAwesomeIcon style={{ height: 16, color: global.theme_white, marginRight: 10 }} icon={faShoppingCart} />*/}
                            {isUpdating == true ?
                                <CircularProgress size={16} style={{ color: global.theme_white }} ></CircularProgress>
                                :
                                <p style={{ ...styles.TextXTiny, color: global.theme_white }}>
                                    {parseInt(sum) == 0 ?
                                        <FontAwesomeIcon style={{ height: 14, color: global.theme_white, marginRight: 10 }} icon={faShoppingBasket} />
                                        : null}
                                    {lang.booking_preview}: {GetPrice(ConvertToPrice(sum))} {lang.money}
                                </p>
                            }
                        </Button>
                    </div>
                }
                <div style={{ ...styles.Block, width: props.isSmall ? 70 : 100, height: global.dialog_bar_height }}>
                    <IconButton onClick={() => Close()} style={{ width: 36, height: 36, backgroundColor: global.theme_white }}>
                        <FontAwesomeIcon style={{ width: 10, color: global.theme_black }} icon={faXmark} />
                    </IconButton>
                </div>
            </div>
            {/* BODY */}
            <div style={{ ...styles.BlockCenter, height: props.height - global.dialog_bar_height, borderBottomLeftRadius: props.radius, borderBottomRightRadius: props.radius, overflowY: 'scroll' }}>
                <div style={{ ...props.isSmall ? styles.BlockCenter : styles.BlockRow, height: props.height - global.dialog_bar_height }}>
                    {props.isSmall ?
                        <div style={{ ...styles.BlockRow, height: selectHeight, backgroundColor: global.theme_back }}>
                            <div style={{ ...styles.Block, height: selectHeight }}>
                                <Select
                                    value={index}
                                    onChange={event => ChangeIndex(event.target.value)}
                                    size='small'
                                    style={{ backgroundColor: global.theme_white, width: '100%' }}
                                >

                                    {categories != false ?
                                        categories.map((item) => (
                                            item.typ != 100 ?
                                                <MenuItem key={item.id} value={item.id}>{item.label}</MenuItem>
                                                : null
                                        ))
                                        : null}
                                </Select>
                            </div>
                            <div style={{ ...styles.Block, height: selectHeight }}>
                                <Button onClick={() => setShowCard(true)} style={{ ...styles.ButtonBlue, width: 190 }}>
                                    {isUpdating == true ?
                                        <CircularProgress size={16} style={{ color: global.theme_white }} ></CircularProgress>
                                        :
                                        <p style={{ ...styles.TextXTiny, color: global.theme_white }}>
                                            {lang.booking_preview}
                                            <FontAwesomeIcon style={{ height: 14, color: global.theme_white, marginLeft: 10 }} icon={faAngleRight} />
                                        </p>
                                    }
                                </Button>
                            </div>
                        </div>
                        :
                        <div style={{ ...styles.BlockCenter, width: menuWidth, height: props.height - global.dialog_bar_height, background: global.themes[props.theme].theme_leftmenu_background, borderBottomLeftRadius: props.radius }}>
                            <div style={{ ...styles.BlockCenter, width: menuWidth, height: props.height - global.dialog_bar_height, msOverflowStyle: 'none', scrollbarWidth: 'none', overflowY: 'scroll' }} className='container'>
                                {categories != false ?
                                    categories.map((item) => (
                                        <Button key={item.id} onClick={() => ChangeIndex(item.id)} style={{ ...styles.ButtonSettingsBig, justifyContent: 'flex-start', backgroundColor: index == item.id ? global.theme_back : '#00000000', color: index == item.id ? font_selected : font_disabled }}>
                                            <div style={{ ...styles.BlockLeft }}>
                                                <p style={{ ...styles.TextSmall, color: global.themes[props.theme].theme_darker, lineHeight: 1, textAlign: 'left', fontWeight: '500' }}>{item.label}</p>
                                                <p style={{ ...styles.TextTiny, color: global.themes[props.theme].theme_darker, marginTop: 2, lineHeight: 1, textAlign: 'left' }}>{item.brand}</p>
                                            </div>
                                        </Button>
                                    ))
                                    : null}

                            </div>
                        </div>
                    }
                    <div style={{ ...styles.BlockCenter, width: props.width - menuWidth, height: props.height - global.dialog_bar_height, backgroundColor: global.theme_back, borderBottomRightRadius: props.radius, overflowY: 'scroll' }}>
                        {/* BODY */}
                        <div style={{ ...styles.Block, width: '98%' }}>
                            <div id={'id_products'}>
                                {subCategories != false ?
                                    subCategories.length > 1 ?
                                        <CategorySelect background={global.theme_back} width={props.width - menuWidth} items={subCategories} value={subCategoryID} func={CategorySelectResult.bind(this)} />
                                        : null
                                    : null}
                            </div>

                            {/* *********************************************************************************************************  
                                ZOZNAM PRODUKTOV
                                ********************************************************************************************************* */}
                            {itemsFiltered != false ?
                                itemsFiltered.map((item, index) => (
                                    <Paper elevation={overID == item.id ? 5 : 2} key={item.id} style={{ ...styles.Block, maxWidth: rowWidth, height: rowHeight, backgroundColor: global.theme_lighter, marginTop: 5, marginBottom: 5, borderRadius: props.isSmall ? 20 : rowHeight / 2, cursor: 'pointer' }}
                                        onMouseOverCapture={() => setOverID(item.id)} onMouseLeave={() => setOverID(-1)}
                                    >
                                        <div style={{ ...styles.BlockRow }}>
                                            {props.isSmall ?
                                                <div onClick={() => Edit(item)} style={{ ...styles.Block, height: rowHeight, width: 90, justifyContent: 'center' }}>
                                                    <img src={item.image == null || item.image == '' ? no_image : item.image.substring(0, 4) == 'http' ? item.image : global.web_images + '/' + item.image} style={{ width: '100%', height: '100%', width: 80, height: 80, objectFit: 'contain', borderRadius: 10, marginLeft: 5 }}></img>
                                                    {item.flag_id == 2 ?
                                                        <div style={{ ...styles.Block, width: 80, height: 20, backgroundColor: global.theme_dark_red, borderRadius: 10, marginTop: 5 }}>
                                                            <p style={{ ...styles.TextXTiny, color: global.theme_white }}>{lang.product_news}</p>
                                                        </div>
                                                        : null}
                                                </div>
                                                :
                                                <div onClick={() => Edit(item)} style={{ ...styles.BlockLeft, height: rowHeight, width: rowHeight, justifyContent: 'center' }}>
                                                    <img src={item.image == null || item.image == '' ? no_image : item.image.substring(0, 4) == 'http' ? item.image : global.web_images + '/' + item.image} style={{ width: '100%', height: '100%', width: rowHeight - 10, height: rowHeight - 10, objectFit: 'contain', borderRadius: rowHeight - 10, marginLeft: 5 }}></img>
                                                </div>
                                            }
                                            {props.isSmall ?
                                                <div onClick={() => Edit(item)} style={{ ...styles.BlockLeft, height: rowHeight, width: '50%', justifyContent: 'center', marginLeft: 10 }}>
                                                    <p style={{ ...styles.TextTiny, fontWeight: '600', textAlign: 'left' }}>{item.label}</p>
                                                    <p style={{ ...styles.TextTiny, marginTop: 0, textAlign: 'left', marginTop: 5 }}>{item.code} {item.details}</p>
                                                    <p style={{ ...styles.TextTiny, textAlign: 'left' }}>{lang.cost_}: {GetPrice(item.cost_price)} {lang.money}</p>
                                                    <p style={{ ...styles.TextTiny }}>{lang.with_dph}</p>
                                                    {props.user.typ == global.account_salon ?
                                                        <p style={{ ...styles.TextTiny, textAlign: 'left', marginTop: 5 }}>{lang.stock}: {item.instock} {lang.pieces}</p>
                                                        : null}
                                                </div>
                                                :
                                                <div onClick={() => Edit(item)} style={{ ...styles.BlockLeft, height: rowHeight, width: '85%', justifyContent: 'center', marginLeft: 10 }}>
                                                    <div style={{ ...styles.BlockRowRaw }}>
                                                        <p style={{ ...styles.TextSmall, fontWeight: '600', textAlign: 'left' }}>{item.label}</p>
                                                        {item.flag_id == 2 ?
                                                            <div style={{ ...styles.Block, width: 90, height: 20, backgroundColor: global.theme_dark_red, borderRadius: 10, marginLeft: 10 }}>
                                                                <p style={{ ...styles.TextXTiny, color: global.theme_white }}>{lang.product_news}</p>
                                                            </div>
                                                            : null}
                                                    </div>
                                                    <div style={{ ...styles.BlockLeft, width: '100%' }}>
                                                        <p style={{ ...styles.TextTiny, marginTop: 0 }}>{item.code} {item.details}</p>
                                                        <div style={{ ...styles.BlockRow, marginTop: 10 }}>
                                                            <div style={{ ...styles.BlockLeft, width: '50%' }}>
                                                                <p style={{ ...styles.TextTiny }}>{lang.cost_}: {GetPrice(item.cost_price)} {lang.money} {lang.with_dph}</p>
                                                            </div>
                                                            <div style={{ ...styles.BlockLeft, width: '30%' }}>
                                                                {props.user.typ == global.account_salon ?
                                                                    <p style={{ ...styles.TextTiny }}>{lang.stock}: {item.instock} {lang.pieces}</p>
                                                                    : null}
                                                            </div>
                                                            <div style={{ ...styles.BlockLeft, width: '20%' }}>
                                                                {item.brand_id == 0 ?
                                                                    <p style={{ ...styles.TextTiny, color: item.eshop == false ? global.theme_red : global.theme_black }}>{lang.eshop}: {item.eshop == true ? lang.yes : lang.no}</p>
                                                                    : null}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            <div style={{ ...styles.Block, height: rowHeight, width: 180, justifyContent: 'center' }}>
                                                <p style={{ ...styles.TextTiny, marginBottom: 5 }}>{item.unit == 1 ? lang.booking_pieces : lang.booking_pack}</p>
                                                <PlusMinus data={item} value={item.quantity} func={PlusMinusResult.bind(this)} />
                                            </div>
                                        </div>
                                    </Paper>
                                )) :
                                // ZIADNE PRODUKTY                            
                                <div style={{ ...styles.Block, paddingTop: 20 }}>
                                    <EmptyList lang={lang} />
                                </div>
                            }

                            {itemsFiltered != false ?
                                pageMax > 1 ?
                                    <div style={{ ...styles.Block, paddingTop: 30, paddingBottom: 30 }}>
                                        <Pagination count={pageMax} size={'small'} page={page + 1} onChange={PageChange} showFirstButton showLastButton />
                                    </div>
                                    : <div style={{ ...styles.Block, paddingTop: 30, paddingBottom: 30 }}>1/1</div>
                                : null}
                        </div>
                    </div>
                </div>
            </div>

            {
                showProduct == true ?
                    <ProductBooking isSmall={props.isSmall} offset={props.offset} theme={props.theme} user={props.user} user_id={props.user.id} product={itemSelected} lang={lang} radius={props.radius} title={itemSelected.label} sub_title={itemSelected.code} backcolor={true} background={true} language={props.language} func={ProductDialogResult.bind(this)} />
                    : null
            }

            {
                showCard == true ?
                    <ProductBookingCard isSmall={props.isSmall} offset={props.offset} theme={props.theme} user={props.user} user_id={props.user.id} lang={lang} radius={props.radius} backcolor={true} background={true} language={props.language} func={ProductCardResult.bind(this)} />
                    : null
            }

            {
                isBusy == true ?
                    <Loading offset={props.offset} theme={props.theme} ></Loading>
                    : null
            }

        </Paper >
    );
}


export const ProductBooking = (props) => {
    /*
            OKNO - full screen
            
            USAGE:
            <ProductBooking radius={props.radius} title={'nazov'} sub_title={'podnázov'} backcolor={true} icon={faQuestion} background={false} func={ProductDialogResult.bind(this)} />

            const ProductDialogResult = (typ,value) => {
                console.log(value)
            }
    */

    const [isBusy, setBusy] = useState(false);
    const [error, setError] = useState(false);
    const [showOK, setShowOK] = useState(false);
    const [showError, setShowError] = useState(false);

    const [photo, setPhoto] = useState(false);
    const [showPhoto, setShowPhoto] = useState(false);
    const [showSelectPhoto, setShowSelectPhoto] = useState(false);

    const [graphData, setGraphData] = useState([]);

    const [product, setProduct] = useState(false);
    const [recommended, setRecommended] = useState(0);

    // Rozmery okna
    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);

    const dialogWidth = width >= 1000 ? 1000 : width;
    const dialogHeight = height >= 768 ? 768 : height;

    const titleHeight = 150;
    const rowOffset = 20;
    const errorHeight = 40;
    const buttonHeight = 100;
    const photoSize = 220;

    const no_image = require('./react/app/no_image.jpg');


    let { func } = props;
    var lang = props.lang;

    var running = false;

    useEffect(() => {
        if (running == false) {
            running = true;

            db_get();

        }
        return () => {
        };

    }, []);

    const db_get = async () => {
        setBusy(true);
        try {
            const response = await fetch(
                global.db_url + 'product_booking', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    salon_id: props.user_id,
                    product_id: props.product.id,
                    default: lang.products_my
                })
            })

            const json = await response.json();

            if (json.ok > 0) {
                setProduct(json.product);
                setPhoto(json.product.image);
                setGraphData(json.graph_data);
                setRecommended(json.recommended);
            }
            setBusy(false);

        } catch (error) {
            console.log(error);
            setBusy(false);
        }
    }

    const db_update = async (data) => {
        setBusy(true);
        try {
            const response = await fetch(
                global.db_url + 'product_booking_update', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    data: data,
                })
            })

            const json = await response.json();

            if (json.ok > 0) {
                product.quantity = data.quantity;
            }
            setBusy(false);

        } catch (error) {
            console.log(error);
            setBusy(false);
        }
    }

    const Press = () => {
        func(product);
    }

    const ShowPhoto = () => {
        if (photo != false && photo != null && photo != '') {
            setShowPhoto(true);
        }
    }

    const DialogImagePreviewResult = () => {
        setShowPhoto(false);
    }

    const SelectPhoto = () => {
        setShowSelectPhoto(true);
    }

    const PhotosResult = (typ, path, file) => {
        setShowSelectPhoto(false);

        if (typ == true) {
            setPhoto(path + file);
        }
    }

    const ShowErrorPress = () => {
        setShowError(false);
    }

    const ShowOKPress = () => {
        setShowOK(false);
    }

    const PlusMinusResult = (value, item) => {

        let data = {
            salon_id: props.user.id,
            product_id: item.id,
            quantity: value,
            sended: false,
            booking_id: 0,
            quantity_original: value,
            cost: item.cost_price
        }
        console.log(data);

        db_update(data);
    }

    const GraphResult = () => {

    }

    return (

        <Backdrop open={true} style={{ paddingLeft: width > global.max_screen ? global.menu_width : 0, backgroundColor: props.backcolor == false ? '#00000000' : '#000000AA' }}>
            <Paper elevation={global.menu_elevation} style={{ width: dialogWidth, height: dialogHeight, background: global.themes[props.theme].theme_dialog_background, borderRadius: props.radius }}>
                <div style={{ ...styles.BlockRow, height: titleHeight, borderTopLeftRadius: props.radius, borderTopRightRadius: props.radius, background: global.themes[props.theme].window_bar_color }}>
                    <div style={{ ...styles.Block, width: titleHeight + 10, height: titleHeight }}>
                        <img onClick={() => ShowPhoto()} src={photo == false || photo == null || photo == '' ? no_image : photo.substring(0, 4) == 'http' ? photo : global.web_images + '/' + photo} style={{ width: '100%', height: '100%', maxWidth: titleHeight - 10, maxHeight: titleHeight - 10, objectFit: 'contain', borderRadius: props.radius * 0.8, cursor: 'pointer' }}></img>
                    </div>
                    <div style={{ ...styles.Block, width: '60%', height: titleHeight, marginLeft: 20 }}>
                        <div style={{ ...styles.BlockLeft, justifyContent: 'center', height: titleHeight }}>
                            <p style={{ ...styles.TextDialogLabel, textAlign: 'left' }}>{props.title}</p>
                            {props.isSmall ? null :
                                <p style={{ ...styles.TextTiny, marginTop: 10 }}>{props.sub_title}</p>
                            }
                            {props.isSmall ? null :
                                <p style={{ ...styles.TextTiny, marginTop: 2 }}>{product.note_short}</p>
                            }
                            <p style={{ ...styles.TextTiny, marginTop: 2 }}>{product.details}</p>
                            <p style={{ ...styles.TextTiny, marginTop: 10 }}>{lang.stock}: {product.instock} {lang.pieces}</p>
                        </div>
                    </div>
                    {props.isSmall ? null :
                        <div style={{ ...styles.Block, height: titleHeight, width: 180, justifyContent: 'center' }}>
                            <p style={{ ...styles.TextTiny }}>{lang.booking_pieces}</p>
                            <PlusMinus data={product} value={product.quantity} func={PlusMinusResult.bind(this)} />
                        </div>
                    }
                    <div style={{ ...styles.Block, width: props.isSmall ? 70 : 100, height: titleHeight }}>
                        <IconButton onClick={() => Press()} style={{ width: 34, height: 34, backgroundColor: global.theme_white }}>
                            <FontAwesomeIcon style={{ width: 10, color: global.theme_black }} icon={faXmark} />
                        </IconButton>
                    </div>
                </div>
                <div style={{ ...styles.BlockCenter, height: dialogHeight - titleHeight, backgroundColor: props.background == true ? global.theme_back : undefined, borderBottomLeftRadius: props.radius, borderBottomRightRadius: props.radius }}>
                    <div style={{ ...styles.BlockCenter, width: '100%', height: dialogHeight - titleHeight - buttonHeight, msOverflowStyle: 'none', scrollbarWidth: 'none', overflowY: 'scroll' }} className='container'>
                        {/* BODY */}
                        {product != false ?
                            <div style={{ ...styles.Block, width: dialogWidth }}>
                                {props.isSmall ?
                                    <p style={{ ...styles.TextTiny, marginTop: 5 }}>{product.note_short}</p>
                                    : null}
                                {props.isSmall ?
                                    <p style={{ ...styles.TextTiny, marginTop: 5 }}>{props.sub_title}</p>
                                    : null}
                                {props.isSmall ?
                                    <div style={{ ...styles.Block, height: 100, justifyContent: 'center' }}>
                                        <p style={{ ...styles.TextTiny, marginBottom: 2 }}>{lang.booking_pieces}</p>
                                        <PlusMinus data={product} value={product.quantity} func={PlusMinusResult.bind(this)} />
                                    </div>
                                    : null}
                                <Graph
                                    lang={props.lang}
                                    elevation={0}
                                    readius={0}
                                    title={lang.booking_stat_label}
                                    sub_title={lang.booking_stat_recommended + ': ' + recommended + ' ' + lang.pieces}
                                    width={props.isSmall ? width : 800}
                                    height={props.isSmall ? 350 : dialogHeight - titleHeight - buttonHeight - 30}
                                    typ={0}
                                    legend={false}
                                    data={graphData}
                                    barWidth={props.isSmall ? 30 : 50}
                                    highColor={global.theme_red}
                                    overColor={global.theme_blue}
                                    showMax={false}
                                    lines={true}
                                    units={lang.pieces}
                                    marginTop={10}
                                    selectable={false}
                                    show_value={true}
                                    isSmall={props.isSmall}
                                    func={GraphResult.bind(this)}
                                />
                                {product.last_date != false ?
                                    <p style={{ ...styles.TextTiny, marginTop: 10 }}>{lang.booking_stat_last_order} {GetDate(product.last_date)}</p>
                                    : null}
                            </div>

                            : null}
                    </div>
                    <div style={{ ...styles.Block, height: buttonHeight }}>
                        <Button onClick={() => Press()} style={{ ...styles.ButtonDark }}>{lang.close}</Button>
                    </div>
                </div>
            </Paper>

            {showSelectPhoto == true ?
                <Photos lang={lang} typ={2} max_size={600} width={600} height={600} full={false} title={lang.photo_select} sub_title={lang.vision_system} radius={props.radius} offset={props.offset} theme={props.theme} func={PhotosResult.bind(this)} />
                : null}

            {showPhoto == true ?
                <DialogImagePreview theme={props.theme} file={GetImageLink(photo)} radius={props.radius} lang={lang} title={lang.preview} sub_title={lang.vision_system} background={global.theme_dark_gray} crop={false} func={DialogImagePreviewResult.bind(this)} />
                : null}

            {showOK == true ?
                <ShowOK theme={props.theme} func={ShowOKPress.bind(this)} />
                : null}

            {showError == true ?
                <ShowError theme={props.theme} text={'Chyba'} func={ShowErrorPress.bind(this)} />
                : null}

            {isBusy == true ?
                <Loading offset={props.offset} theme={props.theme} ></Loading>
                : null}

        </Backdrop>
    );
}

export const ProductBookingCard = (props) => {
    /*
            OKNO - full screen
            
            USAGE:
            <ProductBookingCard radius={props.radius} title={'nazov'} sub_title={'podnázov'} backcolor={true} icon={faQuestion} background={false} func={ProductDialogResult.bind(this)} />

            const ProductDialogResult = (typ,value) => {
                console.log(value)
            }
    */

    const [isBusy, setBusy] = useState(false);
    const [isUpdating, setUpdating] = useState(false);
    const [error, setError] = useState(false);
    const [redrawRequired, setRedrawRequired] = useState(false);
    const [showCheckout, setShowCheckout] = useState(false);
    const [items, setItems] = useState(false);

    // poznámka k objednávke
    const [note, setNote] = useState(LoadBookingNote());

    const [showNote, setShowNote] = useState(false);

    // Suma
    const [sum, setSum] = useState(0);
    const [minSum, setMinSum] = useState(100000);
    const [dph, setDph] = useState(1);

    // cislo objednavky
    const [number, setNumber] = useState('');

    // akciová ponuka    
    const [actionProducts, setActionProducts] = useState(false);
    const [action, setAction] = useState(true);
    const [actionCount, setActionCount] = useState(0);
    const [tags, setTags] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);

    // objednávka odoslana
    const [showOK, setShowOK] = useState(false);
    const [showError, setShowError] = useState(false);

    // Rozmery okna
    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);

    const dialogWidth = width >= 1000 ? 1000 : width;
    const dialogHeight = height >= 900 ? 900 : height;

    const errorHeight = 40;
    const buttonHeight = 80;
    const rowHeight = props.isSmall ? 150 : 100;
    const actionSize = 120;

    const no_image = require('./react/app/no_image.jpg');


    let { func } = props;
    var lang = props.lang;

    var running = false;

    useEffect(() => {
        if (running == false) {
            running = true;

            db_get();

        }
        return () => {
        };

    }, []);

    const db_get = async () => {
        setBusy(true);
        try {
            const response = await fetch(
                global.db_url + 'products_booking_card', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    language: props.language,
                    salon_id: props.user_id,
                })
            })

            const json = await response.json();
            Debug('products_booking_card');
            Debug(json);
            if (json.ok > 0) {
                setItems(json.items);
                setSum(json.sum);
                setMinSum(json.min_sum);
                setNumber(json.number);
                setDph(json.dph);
                setActionProducts(json.action_items);

                setActionCount(GetAction(json.items));
            }
            setBusy(false);

        } catch (error) {
            console.log(error);
            setBusy(false);
        }
    }

    const db_update = async (data, reload) => {
        setBusy(true);
        try {
            const response = await fetch(
                global.db_url + 'product_booking_update', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    data: data,
                })
            })

            const json = await response.json();
Debug(json);
            if (json.ok > 0) {
                var tmp = items.find(x => x.product_id == data.product_id);
                if (tmp != undefined) {
                    tmp.quantity = data.quantity
                    setSum(json.sum);
                }
                setActionCount(GetAction(items));
                setRedrawRequired(true);

                if (reload == true) {
                    db_get();
                }
            }
            setBusy(false);

        } catch (error) {
            console.log(error);
            setBusy(false);
        }
    }

    const db_checkout = async (data) => {
        setBusy(true);
        try {
            const response = await fetch(
                global.db_url + 'products_booking_checkout', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    language: props.language,
                    data: data,

                    // PREKLADY TEXTOV
                    lang: {
                        label: lang.booking_email_label,
                        do_not_reply: lang.do_not_reply,
                        quantity: lang.quantity,
                        code: lang.code_,
                        product_name: lang.product_name
                    }
                })
            })

            const json = await response.json();
            Debug(json);
            if (json.ok > 0) {
                SaveBookingNote('');
                setRedrawRequired(true);
                setShowOK(true);
            } else {
                setShowError(true);
            }
            setBusy(false);

        } catch (error) {
            console.log(error);
            setBusy(false);
        }
    }

    const Press = () => {
        func(redrawRequired);
    }


    const PlusMinusResult = (value, item) => {

        let data = {
            salon_id: props.user.id,
            product_id: item.product_id,
            quantity: value,
            sended: false,
            booking_id: 0,
            quantity_original: value,
            cost: item.cost_price
        }

        db_update(data, false);
    }

    const CheckoutResult = (typ) => {
        setShowCheckout(false);
        if (typ == true) {
            let data = {
                number: number,
                salon_id: props.user.id,
                agent_id: props.user.agent_id,
                status: 0,
                note: note,
                language: props.language,
                creator: 0
            }

            db_checkout(data);
        }
    }

    const DialogEnterTextResult = (typ, text) => {
        setShowNote(false);
        if (typ == true) {
            setNote(text);
            SaveBookingNote(text);
        }
    }

    const DialogOKResult = () => {
        setShowOK(false);
        Press();
    }

    const DialogErrorResult = () => {
        setShowError(false);
        Press();
    }

    const GetAction = (items_) => {
        var count = 0
        var tags_ = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

        if (items_ != false) {
            items_.forEach(element => {
                if (element.category_id == 4 || element.category_id == 10) {
                    count = count + parseInt(element.quantity);
                }
                if (element.tags != false) {
                    element.tags.forEach(tag => {
                        tags_[tag] += parseInt(element.quantity);
                    });
                }
            });
        }
        setTags(tags_);
        return count;
    }

    const AddToCard = (item, quantity) => {

        let data = {
            salon_id: props.user.id,
            product_id: item.id,
            quantity: quantity,
            sended: false,
            booking_id: 0,
            quantity_original: quantity,
            cost: item.cost_price,
        }

        Debug(data);
        db_update(data, true);
    }

    const ActionRow = (props) => {

        var item = actionProducts != false ? actionProducts.find(x => x.code == props.code && parseInt(x.action) == 1 && parseInt(x.booking) == 1) : undefined;
        var inCard = items != false ? items.find(x => x.code == props.code) == undefined ? false : true : false;

        return (
            item != undefined ?
                <Paper elevation={3} style={{ ...styles.Block, width: actionSize, minHeight: actionSize, margin: 5, borderRadius: 5 }}>
                    <img src={item.image == null || item.image == '' ? no_image : item.image.substring(0, 4) == 'http' ? item.image : global.web_images + '/' + item.image} style={{ width: '100%', height: '100%', width: actionSize, height: actionSize, objectFit: 'contain', borderTopRightRadius: 5, borderTopLeftRadius: 5 }}></img>
                    <div style={{ ...styles.Block, width: '98%', height: 30, overflow: 'hidden', }}>
                        <TextLine text={item.label} fontSize={global.font_tiny} fontWeight={'600'} color={global.theme_black} />
                    </div>
                    <div style={{ ...styles.Block, width: '98%', borderTop: '1px solid #d0d0d0', height: 30, overflow: 'hidden' }}>
                        <p style={{ ...styles.TextXSmall, color: global.theme_black }}>{props.count} {lang.pieces}</p>
                    </div>
                    <div style={{ ...styles.Block, width: '98%', height: 36 }}>
                        {props.count > 0 ?
                            inCard == true ?
                                <p style={{ ...styles.TextXSmall, color: global.theme_black }}>{lang.product_in_basket}</p>
                                :
                                <Button onClick={() => AddToCard(item, props.count)} style={{ ...styles.ButtonDark, height: 36, width: actionSize, borderRadius: 0 }}>{lang.product_buy}</Button>
                            : null}
                    </div>
                </Paper>
                : null
        );
    }

    return (

        <Backdrop open={true} style={{ paddingLeft: width > global.max_screen ? global.menu_width : 0, backgroundColor: props.backcolor == false ? '#00000000' : '#000000AA' }}>
            <Paper elevation={global.menu_elevation} style={{ width: dialogWidth, height: dialogHeight, background: global.themes[props.theme].theme_dialog_background, borderRadius: props.radius }}>
                <div style={{ ...styles.BlockRow, height: global.dialog_bar_height, borderTopLeftRadius: props.radius, borderTopRightRadius: props.radius, background: global.themes[props.theme].window_bar_color }}>
                    {props.isSmall ? null :
                        <div style={{ ...styles.Block, width: 100, height: global.dialog_bar_height }}>
                            <div style={{ ...styles.Block, width: global.dialog_icon_size, height: global.dialog_icon_size, background: global.themes[props.theme].icon_background, borderRadius: 10 }} >
                                <FontAwesomeIcon style={{ height: 20, color: global.theme_white }} icon={faShoppingBasket} />
                            </div>
                        </div>
                    }
                    <div style={{ ...styles.Block, width: props.isSmall ? '40%' : '58%', height: global.dialog_bar_height }}>
                        <div style={{ ...styles.BlockLeft, height: global.dialog_bar_height, justifyContent: 'center' }}>
                            <p style={{ ...styles.TextDialogLabel, textAlign: 'left', marginLeft: props.isSmall ? 10 : 0 }}>{props.isSmall ? props.lang.desktop_booking_products : props.lang.booking_card}</p>
                            {props.isSmall ? null :
                                <p style={{ ...styles.TextDialogSubLabel, marginTop: 4 }}>{props.lang.products}</p>
                            }
                        </div>
                    </div>

                    <div style={{ ...styles.Block, width: 240, height: global.dialog_bar_height }}>
                        <div style={{ ...styles.Block, height: global.dialog_bar_height - 8, backgroundColor: global.theme_white, borderRadius: props.radius / 2 }}>
                            {isUpdating == false ?
                                <div style={{ ...styles.Block, height: global.dialog_bar_height - 8 }}>
                                    <p style={{ ...props.isSmall ? styles.TextTiny : styles.TextTiny }}>{lang.sumar}</p>
                                    <p style={{ ...props.isSmall ? styles.TextTiny : styles.TextNormal, marginTop: 2, fontWeight: '600' }}>{GetPrice(ConvertToPrice(sum))} {props.lang.money} <span style={{ ...styles.TextTiny }}>{lang.with_dph}</span></p>
                                    <p style={{ ...styles.TextTiny, marginTop: 2 }}>{GetPrice(ConvertToPrice(sum / dph))} {props.lang.money} {lang.without_dph}</p>
                                </div>
                                : <div style={{ ...styles.Block, height: global.dialog_bar_height - 4 }}>
                                    <CircularProgress size={16}></CircularProgress>
                                </div>
                            }
                        </div>
                    </div>

                    <div style={{ ...styles.Block, width: 100, height: global.dialog_bar_height }}>
                        <IconButton onClick={() => Press(false)} style={{ width: 34, height: 34, backgroundColor: global.theme_white }}>
                            <FontAwesomeIcon style={{ width: 10, color: global.theme_black }} icon={faXmark} />
                        </IconButton>
                    </div>
                </div>
                <div style={{ ...styles.BlockCenter, height: dialogHeight - global.dialog_bar_height, backgroundColor: props.background == true ? global.theme_back : undefined, borderBottomLeftRadius: props.radius, borderBottomRightRadius: props.radius }}>
                    <div style={{ ...styles.BlockCenter, width: '100%', height: dialogHeight - global.dialog_bar_height - buttonHeight }}>
                        {/* BODY */}
                        <div style={{ ...styles.BlockCenter, width: '100%', height: dialogHeight - global.dialog_bar_height - buttonHeight, overflowY: 'scroll', paddingTop: 10, paddingBottom: 10 }}>

                            {action == true ?
                                //
                                // ************************************************************************************
                                // AKCIOVA PONUKA
                                // ************************************************************************************
                                //
                                <Paper elevation={0} style={{ ...styles.Block, width: '96%', backgroundColor: global.theme_back, marginTop: 0, marginBottom: 10 }}>
                                    <div style={{ ...styles.Block, width: undefined }}>
                                        <p style={{ ...styles.TextXSmall, color: global.theme_black }}><b>{lang.action_offer} -</b> {lang.action_text}:</p>
                                    </div>
                                    <div style={{ ...styles.Block, marginTop: 5 }}>
                                        {actionProducts != false ?
                                            <div style={{ ...styles.BlockRow, flexWrap: 'wrap', justifyContent: 'center' }}>
                                                <ActionRow code={'V470202'} count={parseInt(actionCount / 2)} />
                                                <ActionRow code={'P910156'} count={parseInt(actionCount / 3)} />
                                                <ActionRow code={'EXXR007'} count={Math.min(tags[1], tags[2])} />
                                                <ActionRow code={'V680601'} count={parseInt(tags[3] / 2) + parseInt(tags[4])} />
                                                <ActionRow code={'V680702'} count={parseInt(tags[5]) >= 8 ? parseInt(tags[5] / 2) : 0} />
                                                <ActionRow code={'EXXR008'} count={Math.min(parseInt(tags[6] / 2) + tags[1], tags[2])} />
                                            </div>
                                            : null}
                                    </div>

                                    <p style={{ ...styles.TextXSmall, color: global.theme_dark, marginTop: 10 }}>{lang.action_product_add}</p>
                                </Paper>
                                : null}

                            {note != '' ?
                                //
                                // ************************************************************************************
                                // POZNAMKA
                                // ************************************************************************************
                                //
                                <Paper elevation={2} style={{ ...styles.Block, width: '96%', minHeight: rowHeight, backgroundColor: global.theme_lighteen_red, paddingTop: 2, paddingBottom: 2, marginTop: 2, marginBottom: 2, borderRadius: 10 }}>
                                    <p style={{ ...styles.TextTiny, fontWeight: '600' }}>{lang.eshop_note}:</p>
                                    <p style={{ ...styles.TextTiny, marginTop: 5 }}>{note}</p>
                                </Paper>
                                : null}

                            {items != false ?
                                //
                                // ************************************************************************************
                                // ZOZNAM PRODUKTOV
                                // ************************************************************************************
                                //
                                items.map((item, index) => (
                                    <Paper elevation={2} key={item.id} style={{ ...styles.Block, width: '96%', minHeight: rowHeight, backgroundColor: global.theme_lighter, marginTop: 5, marginBottom: 5, borderRadius: props.isSmall ? 20 : rowHeight / 2 }}>
                                        <div style={{ ...styles.BlockRow }}>
                                            {props.isSmall ?
                                                <div style={{ ...styles.BlockLeft, minHeight: rowHeight, width: 90, justifyContent: 'center' }}>
                                                    <img src={item.image == null || item.image == '' ? no_image : item.image.substring(0, 4) == 'http' ? item.image : global.web_images + '/' + item.image} style={{ width: '100%', height: '100%', width: 80, height: 80, objectFit: 'contain', borderRadius: 10, marginLeft: 5 }}></img>
                                                </div>
                                                :
                                                <div style={{ ...styles.BlockLeft, minHeight: rowHeight, width: rowHeight, justifyContent: 'center' }}>
                                                    <img src={item.image == null || item.image == '' ? no_image : item.image.substring(0, 4) == 'http' ? item.image : global.web_images + '/' + item.image} style={{ width: '100%', height: '100%', width: rowHeight - 10, height: rowHeight - 10, objectFit: 'contain', borderRadius: rowHeight - 10, marginLeft: 5 }}></img>
                                                </div>
                                            }
                                            {props.isSmall ?
                                                <div style={{ ...styles.BlockLeft, minHeight: rowHeight, width: '60%', justifyContent: 'center', marginLeft: 10 }}>
                                                    <p style={{ ...styles.TextSmall, fontWeight: '600', textAlign: 'left' }}>{item.label}</p>
                                                    <p style={{ ...styles.TextTinyMobile, marginTop: 0, textAlign: 'left' }}>{item.code} <span style={{ ...styles.TextTiny }}>{item.details}</span></p>
                                                    <p style={{ ...styles.TextTinyMobile, marginTop: 10, textAlign: 'left' }}>{lang.cost_}: {GetPrice(item.cost_price)} {lang.money}/1{lang.pieces}</p>
                                                </div>
                                                :
                                                <div style={{ ...styles.BlockLeft, minHeight: rowHeight, width: '85%', justifyContent: 'center', marginLeft: 10 }}>
                                                    <p style={{ ...styles.TextSmall, fontWeight: '600', textAlign: 'left' }}>{item.label}</p>
                                                    <div style={{ ...styles.BlockLeft, width: '100%' }}>
                                                        <p style={{ ...styles.TextTiny, marginTop: 0 }}>{item.code} <span style={{ ...styles.TextTiny }}>{item.details}</span></p>
                                                        <div style={{ ...styles.BlockRow, marginTop: 10 }}>
                                                            <div style={{ ...styles.BlockLeft, width: '40%' }}>
                                                                <p style={{ ...styles.TextTiny }}>{lang.cost_}: {GetPrice(item.cost_price)} {lang.money}/1{lang.pieces} {lang.with_dph}</p>
                                                            </div>
                                                            <div style={{ ...styles.BlockLeft, width: '40%' }}>

                                                            </div>
                                                            <div style={{ ...styles.BlockLeft, width: '20%' }}>
                                                                {item.brand_id == 0 ?
                                                                    <p style={{ ...styles.TextTiny, color: item.eshop == false ? global.theme_red : global.theme_black }}>{lang.eshop}: {item.eshop == true ? lang.yes : lang.no}</p>
                                                                    : null}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            <div style={{ ...styles.Block, minHeight: rowHeight, width: 180, justifyContent: 'center' }}>
                                                <p style={{ ...styles.TextTiny }}>{lang.booking_pieces}</p>
                                                <PlusMinus data={item} value={item.quantity} func={PlusMinusResult.bind(this)} />
                                            </div>
                                        </div>
                                    </Paper>
                                )) :
                                // ZIADNE PRODUKTY                            
                                <div style={{ ...styles.Block, paddingTop: 20 }}>
                                    <EmptyList lang={lang} />
                                </div>
                            }

                            <div style={{ ...styles.Block, minHeight: 100 }}></div>

                        </div>
                    </div>
                    <div style={{ ...styles.Block, width: '100%', height: buttonHeight, backgroundColor: global.themes[props.theme].theme_lighter, borderBottomLeftRadius: props.radius, borderBottomRightRadius: props.radius }}>
                        {parseFloat(minSum) <= parseFloat(sum) ? items.length > 0 ?
                            <div style={{ ...styles.BlockRow }}>
                                <div style={{ ...styles.BlockLeft, width: '50%', height: buttonHeight, justifyContent: 'center' }}>
                                    <Button onClick={() => setShowNote(true)} style={{ ...styles.ButtonDark, backgroundColor: global.themes[props.theme].button_dark, width: props.isSmall ? 160 : 220, marginLeft: 20 }}>
                                        {props.isSmall ? null :
                                            <FontAwesomeIcon style={{ height: 16, color: global.theme_white, marginRight: 10 }} icon={faPen} />
                                        }
                                        <p style={{ ...props.isSmall ? styles.TextXTiny : styles.TextTiny, color: global.theme_white }}>{note.trim() == '' ? lang.booking_note : lang.booking_note_edit}</p>
                                    </Button>
                                </div>
                                <div style={{ ...styles.BlockRight, width: '50%', height: buttonHeight, justifyContent: 'center' }}>
                                    {props.user.agent_id > 0 ?
                                        <Button onClick={() => setShowCheckout(true)} style={{ ...styles.ButtonDark, backgroundColor: global.themes[props.theme].button_dark, width: props.isSmall ? 160 : 220, marginRight: 20 }}>
                                            <p style={{ ...props.isSmall ? styles.TextXTiny : styles.TextTiny, color: global.theme_white }}>{props.isSmall ? lang.send : lang.booking_checkout}</p>
                                            {props.isSmall ? null :
                                                <FontAwesomeIcon style={{ height: 16, color: global.theme_white, marginLeft: 10 }} icon={faAngleRight} />
                                            }
                                        </Button>
                                        :
                                        <p style={{ ...styles.TextSmall, marginRight: 30 }}>{props.lang.agent_error}</p>
                                    }
                                </div>
                            </div>
                            : null
                            :
                            <p style={{ ...styles.TextSmall, fontWeight: '500' }}>{lang.booking_min_sum} {minSum} {lang.money}</p>
                        }
                    </div>
                </div>
            </Paper>

            {showNote == true ?
                <DialogEnterText theme={props.theme} rows={9} radius={props.radius} title={lang.booking_note} sub_title={''} text={note} icon={faPen} button={props.lang.save} func={DialogEnterTextResult.bind(this)} />
                : null}

            {showOK == true ?
                <DialogInfo theme={props.theme} radius={props.radius} title={lang.booking_sended_label} sub_title={''} text={lang.booking_sended_text} icon={faInfo} button={props.lang.close} icon_show={faCheckCircle} icon_color={global.theme_darker_green} func={DialogOKResult.bind(this)} />
                : null}

            {showError == true ?
                <DialogInfo theme={props.theme} radius={props.radius} title={lang.booking_error_label} sub_title={''} text={lang.booking_error_text} icon={faInfo} button={props.lang.close} icon_show={faXmark} icon_color={global.theme_dark_red} func={DialogErrorResult.bind(this)} />
                : null}

            {showCheckout == true ?
                <DialogYesNo theme={props.theme} radius={props.radius} title={lang.booking_checkout + '?'} sub_title={''} text={lang.booking_checkout_question} sub_text={note.trim() == '' ? lang.booking_note_not_included : lang.booking_note_included} icon={faQuestion} yes={props.lang.yes} no={props.lang.no} yes_color={global.theme_dark_red} no_color={global.themes[props.theme].button_dark} func={CheckoutResult.bind(this)} />
                : null}

            {isBusy == true ?
                <Loading offset={props.offset} theme={props.theme} ></Loading>
                : null}

        </Backdrop>
    );
}
